import { render, staticRenderFns } from "./case.face.vue?vue&type=template&id=3f3be27e&"
import script from "./case.face.vue?vue&type=script&lang=js&"
export * from "./case.face.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports